import {
  buildAnalyticsContext,
  getVisibleCtaLabel,
} from "./funnel-analytics"

const WHATSAPP_HOSTNAMES = new Set([
  "api.whatsapp.com",
  "chat.whatsapp.com",
  "wa.me",
  "www.wa.me",
  "whatsapp.com",
  "www.whatsapp.com",
])

export function getContactEventName(href, origin) {
  const normalizedHref = String(href || "").trim()

  if (/^tel:/i.test(normalizedHref)) {
    return "phone_click"
  }

  try {
    const url = new URL(
      normalizedHref,
      origin || "https://www.team-laurien-alex.de/",
    )

    if (
      WHATSAPP_HOSTNAMES.has(url.hostname.toLowerCase()) ||
      /^whatsapp:/i.test(url.protocol)
    ) {
      return "whatsapp_click"
    }
  } catch (_) {
    return null
  }

  return null
}

export function getContactEventParameters(link, location, viewportWidth) {
  return buildAnalyticsContext({
    pagePath: location?.pathname,
    ctaLocation:
      link?.getAttribute?.("data-analytics-cta-location") ||
      link?.getAttribute?.("data-ga-location"),
    ctaLabel: getVisibleCtaLabel(link),
    programInterest: link?.getAttribute?.(
      "data-analytics-program-interest",
    ),
    viewportWidth,
  })
}
